import type { RouterProviderProps } from "react-router-dom";
import { RouterProvider } from "react-router-dom";
import { memo, useMemo } from "react";

import { getRouter } from "@routes/index.tsx";
import { useUserStore } from "@/stores/userStore";

export const AppRouter = memo(function AppRouter(
  props: Omit<RouterProviderProps, "router">,
) {
  const role = useUserStore((state) => state.role);

  const router = useMemo(() => {
    return getRouter(role);
  }, [role]);

  return <RouterProvider router={router} {...props} />;
});
